import React from "react";
import { createRoot } from "react-dom/client";
import UltraPage from "./Ultra";

const container =
    document.getElementById("ultra-root") || document.getElementById("root");

if (container) {
    const root = createRoot(container);
    root.render(<UltraPage />);
} else {
    console.warn("Aucun élément #ultra-root ni #root trouvé pour UltraPage");
}
